import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=095b811a&scoped=true&"
import script from "./Offer.vue?vue&type=script&lang=ts&"
export * from "./Offer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b811a",
  null
  
)

export default component.exports